import { apiClient } from '../../config/axios.config'; /* Adjust the import path as necessary */
import { BASE_URL, BASE_FAQ_URL } from '../apiConfig';

/* Fetch FAQ Headers    */
const getHeaders = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/getheaders`,
    payload,
  );
  return response;
};

/* Add new FAQ Headers  */
const addNewHeaders = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/addheaders`,
    payload,
  );
  return response.result;
};

/* Update FAQ Headers  */
const updateHeaders = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/updateheaders`,
    payload,
  );
  return response;
};

/* Delete FAQ Headers  */
const deleteHeaders = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/deleteheaders`,
    payload,
  );
  return response;
};

/* Add new FAQ Question and Answer Details  */
const addQaDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/addqa`,
    payload,
  );
  return response.data;
};

/* Fetch all FAQ Question and Answers based on Headers  */
const getQaDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/getqa`,
    payload,
  );
  return response;
};

/* Fetch all FAQ Question and Answers based on Headers  */
const updateQaDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/updateqa`,
    payload,
  );
  return response;
};

/* Fetch all FAQ Question and Answers based on Headers  */
const deleteQaDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_FAQ_URL}/deleteqa`,
    payload,
  );
  return response;
};

export {
  getHeaders,
  addNewHeaders,
  updateHeaders,
  deleteHeaders,
  addQaDetails,
  getQaDetails,
  updateQaDetails,
  deleteQaDetails,
};
